import { Route } from "react-router";
import { all_routes } from "./all_routes";
import Calendar from "../mainMenu/apps/calendar";
import DataTable from "../tables/dataTable";
import BasicTable from "../tables/basicTable";
import Login from "../auth/login/login";
import Register from "../auth/register/register";
import TwoStepVerification from "../auth/twoStepVerification/twoStepVerification";
import EmailVerification from "../auth/emailVerification/emailVerification";
import ResetPassword from "../auth/resetPassword/resetPassword";
import ForgotPassword from "../auth/forgotPassword/forgotPassword";
import Accordion from "../uiInterface/base-ui/accordion";
import Avatar from "../uiInterface/base-ui/avatar";
import Borders from "../uiInterface/base-ui/borders";
import Breadcrumb from "../uiInterface/base-ui/breadcrumb";
import Buttons from "../uiInterface/base-ui/buttons";
import ButtonsGroup from "../uiInterface/base-ui/buttonsgroup";
import Cards from "../uiInterface/base-ui/cards";
import Carousel from "../uiInterface/base-ui/carousel";
import Colors from "../uiInterface/base-ui/colors";
import Dropdowns from "../uiInterface/base-ui/dropdowns";
import Grid from "../uiInterface/base-ui/grid";
import Images from "../uiInterface/base-ui/images";
import Lightboxes from "../uiInterface/base-ui/lightbox";
import Media from "../uiInterface/base-ui/media";
import Modals from "../uiInterface/base-ui/modals";
import NavTabs from "../uiInterface/base-ui/navtabs";
import Offcanvas from "../uiInterface/base-ui/offcanvas";
import Pagination from "../uiInterface/base-ui/pagination";
import Popovers from "../uiInterface/base-ui/popover";
import RangeSlides from "../uiInterface/base-ui/rangeslider";
import Progress from "../uiInterface/base-ui/progress";
import Spinner from "../uiInterface/base-ui/spinner";
import Toasts from "../uiInterface/base-ui/toasts";
import Typography from "../uiInterface/base-ui/typography";
import Video from "../uiInterface/base-ui/video";
import ClipBoard from "../uiInterface/advanced-ui/clipboard";
import Counter from "../uiInterface/advanced-ui/counter";
import DragAndDrop from "../uiInterface/advanced-ui/dragdrop";
import Rating from "../uiInterface/advanced-ui/rating";
import Stickynote from "../uiInterface/advanced-ui/stickynote";
import TextEditor from "../uiInterface/advanced-ui/texteditor";
import Timeline from "../uiInterface/advanced-ui/timeline";
import Scrollbar from "../uiInterface/advanced-ui/uiscrollbar";
import Apexchart from "../uiInterface/charts/apexcharts";
import FeatherIcons from "../uiInterface/icons/feathericon";
import FontawesomeIcons from "../uiInterface/icons/fontawesome";
import MaterialIcons from "../uiInterface/icons/materialicon";
import PE7Icons from "../uiInterface/icons/pe7icons";
import SimplelineIcons from "../uiInterface/icons/simplelineicon";
import ThemifyIcons from "../uiInterface/icons/themify";
import TypiconIcons from "../uiInterface/icons/typicons";
import WeatherIcons from "../uiInterface/icons/weathericons";
import BasicInputs from "../uiInterface/forms/formelements/basic-inputs";
import CheckboxRadios from "../uiInterface/forms/formelements/checkbox-radios";
import InputGroup from "../uiInterface/forms/formelements/input-group";
import GridGutters from "../uiInterface/forms/formelements/grid-gutters";
import FormSelect from "../uiInterface/forms/formelements/form-select";
import FormMask from "../uiInterface/forms/formelements/form-mask";
import FileUpload from "../uiInterface/forms/formelements/fileupload";
import FormHorizontal from "../uiInterface/forms/formelements/layouts/form-horizontal";
import FormVertical from "../uiInterface/forms/formelements/layouts/form-vertical";
import FloatingLabel from "../uiInterface/forms/formelements/layouts/floating-label";
import FormValidation from "../uiInterface/forms/formelements/layouts/form-validation";
import FormSelect2 from "../uiInterface/forms/formelements/layouts/form-select2";
import FormWizard from "../uiInterface/forms/formelements/form-wizard";
import DataTables from "../uiInterface/table/data-tables";
import TablesBasic from "../uiInterface/table/tables-basic";
import IonicIcons from "../uiInterface/icons/ionicicons";
import Badges from "../uiInterface/base-ui/badges";
import Placeholder from "../uiInterface/base-ui/placeholder";
import Alert from "../uiInterface/base-ui/alert";
import Tooltips from "../uiInterface/base-ui/tooltips";
import Ribbon from "../uiInterface/advanced-ui/ribbon";
import AdminDashboard from "../mainMenu/adminDashboard";
import AlertUi from "../uiInterface/base-ui/alert-ui";
import TeacherDashboard from "../mainMenu/teacherDashboard";
import StudentDasboard from "../mainMenu/studentDashboard";
import ParentDashboard from "../mainMenu/parentDashboard";
import Login2 from "../auth/login/login-2";
import Login3 from "../auth/login/login-3";
import ResetPassword2 from "../auth/resetPassword/resetPassword-2";
import ResetPassword3 from "../auth/resetPassword/resetPassword-3";
import TwoStepVerification2 from "../auth/twoStepVerification/twoStepVerification-2";
import TwoStepVerification3 from "../auth/twoStepVerification/twoStepVerification-3";
import Register2 from "../auth/register/register-2";
import Register3 from "../auth/register/register-3";
import ForgotPassword2 from "../auth/forgotPassword/forgotPassword-2";
import ForgotPassword3 from "../auth/forgotPassword/forgotPassword-3";
import ResetPasswordSuccess from "../auth/resetPasswordSuccess/resetPasswordSuccess";
import ResetPasswordSuccess2 from "../auth/resetPasswordSuccess/resetPasswordSuccess-2";
import ResetPasswordSuccess3 from "../auth/resetPasswordSuccess/resetPasswordSuccess-3";
import LockScreen from "../auth/lockScreen";
import EmailVerification2 from "../auth/emailVerification/emailVerification-2";
import EmailVerification3 from "../auth/emailVerification/emailVerification-3";
import AddGroup from "../academic/examinations/groups/addGroup";
import EditGroup from "../academic/examinations/groups/editGroup";
import Groups from "../academic/examinations/groups";
import Users from "../academic/examinations/Users";
import AddUser from "../academic/examinations/Users/addUser";
import EditUser from "../academic/examinations/Users/editUser";
import UserProfile from "../academic/examinations/Users/userProfile";
import StudentData from "../academic/examinations/studentsData";
import Dispositions from "../academic/examinations/dispositions";
import Categories from "../academic/examinations/categories";
import SubCategories from "../academic/examinations/subCategories";
import Priorities from "../academic/examinations/proirites";
import TicketStatus from "../academic/examinations/ticketStatus";
import AddDisposition from "../academic/examinations/dispositions/addDisposition";
import EditDisposition from "../academic/examinations/dispositions/editDisposition";
import AddCategory from "../academic/examinations/categories/addCategory";
import EditCategory from "../academic/examinations/categories/editCategory";
import AddSubCategory from "../academic/examinations/subCategories/addSubCategory";
import AddPriority from "../academic/examinations/proirites/addPriorities";
import EditPriority from "../academic/examinations/proirites/editPriorities";
import AddTicketStatus from "../academic/examinations/ticketStatus/addTicketStatus";
import EditTicketStatus from "../academic/examinations/ticketStatus/editTicketStatus";
import EditSubCatgegory from "../academic/examinations/subCategories/editSubCategory";
import AddTypeOfTicket from "../academic/examinations/typeOfTicket/addTypeOfTicket";
import TypeOfTicket from "../academic/examinations/typeOfTicket";
import EditTypeOfTicket from "../academic/examinations/typeOfTicket/editTypeOfTicket";
import AddWizklubTicket from "../academic/examinations/WizklubTicket/addTicket";
import EditWizklubTicket from "../academic/examinations/WizklubTicket/editTicket";
import WizklubView from "../academic/examinations/WizklubView";
import SummerCampDisposition from "../academic/examinations/SummerCampDisposition";
import SummerCampAddDisposition from "../academic/examinations/SummerCampDisposition/addDispositionSummercamp";
import SummerCampEditDisposition from "../academic/examinations/SummerCampDisposition/editDispositionSummerCamp";
import SummerCampCategories from "../academic/examinations/SummerCampCategories.tsx";
import SummerCampAddCategory from "../academic/examinations/SummerCampCategories.tsx/addCategorySummerCamp";
import SummerCampAddSubCategory from "../academic/examinations/SummerCampSubCategory/addSubCategorySummerCamp";
import SummerCampSubCategories from "../academic/examinations/SummerCampSubCategory";
import SummerCampEditSubCatgegory from "../academic/examinations/SummerCampSubCategory/editSubCategorySummerCamp";
import SummerCampPriorities from "../academic/examinations/SummerCampPriority";
import SummerCampAddPriority from "../academic/examinations/SummerCampPriority/addPrioritySummerCamp";
import SummerCampEditPriority from "../academic/examinations/SummerCampPriority/editPrioritySummerCamp";
import SummerCampAddTicketStatus from "../academic/examinations/SummerCampTicketStatus/addTicketStatusSummerCamp";
import SummerCampTicketStatus from "../academic/examinations/SummerCampTicketStatus";
import SummerCampEditTicketStatus from "../academic/examinations/SummerCampTicketStatus/editTicketStatusSummerCamp";
import SummerCampEditCategory from "../academic/examinations/SummerCampCategories.tsx/editCategorySummerCamp";
import SummerCampStudents from "../academic/examinations/SummerCampStudents";
import AddSummerCampTicket from "../academic/examinations/SummerCampTickets/addSummerCampTicket";
import UpdateSummerCampTicket from "../academic/examinations/SummerCampTickets/updateSummerCampTickets";
import Profile from "../academic/examinations/profile";
import AgentCallSummary from "../academic/examinations/agentsCallSummary";
import AgentWiseCallLogs from "../academic/examinations/agentWiseCallLogs";
import AgentWiseTargetStatus from "../academic/examinations/agentWiseTargetStatus";
import AgentWiseStudentStatus from "../academic/examinations/agentWiseStudentStatus";
import NotificationActivities from "../../core/common/header/actvities";
import AgentTargets from "../academic/examinations/agentTargets";
import SummerCampCallBacks from "../academic/examinations/summerCampCallBacks";
import AddSummerCampTargetTicket from "../academic/examinations/summerCampTargetTickets/addSummerCampTargetTickets";
import UpdateSummerCampTargetTicket from "../academic/examinations/summerCampTargetTickets/updateSummerCampTargetTickets";
import AddSummerCampCallBackTicket from "../academic/examinations/summerCampCallBackTickets/addSummerCampCallBackTickets";
import UpdateSummerCampCallBackTicket from "../academic/examinations/summerCampCallBackTickets/updateSummerCampCallBackTickets";
import BranchWizclubOrOffline from "../academic/examinations/branchesWizclubOrOffline";
import AgentWiseStudentSales from "../academic/examinations/agentWiseStudentSales";
import TeamManagmentList from "../academic/examinations/teamManagment/teamManagementList";
import AddTeamManagement from "../academic/examinations/teamManagment/addTeamManagementList";
import EditTeamManagementList from "../academic/examinations/teamManagment/editTeamManagementList";
import AgentGroupTypes from "../academic/examinations/teamManagment/agentGroupTypesList";
import AddAgentGroupType from "../academic/examinations/teamManagment/addAgentGroupType";
import EditAgentGroupType from "../academic/examinations/teamManagment/editAgentGroupType";
import AgentGroups from "../academic/examinations/teamManagment/agentGroupsList";
import AddAgentGroup from "../academic/examinations/teamManagment/addAgentGroup";
import EditAgentGroup from "../academic/examinations/teamManagment/editAgentGroup";
import SummerCampCompletedTargets from "../academic/examinations/summerCampCompletedTargets";
import WizClubCategories from "../academic/examinations/WizClubCategories";
import WizClubAddCategory from "../academic/examinations/WizClubCategories/addWixClubCategory";
import WizClubEditCategory from "../academic/examinations/WizClubCategories/editWizClubCategory";
import WizklubSubCategories from "../academic/examinations/wizklubSubCategories";
import AddWizklubSubCategories from "../academic/examinations/wizklubSubCategories/addWizklubSubCategory";
import EditWizklubSubCategories from "../academic/examinations/wizklubSubCategories/editWizklubSubCategory";
import WizklubStudents from "../academic/examinations/wizklubStudents";
import AddOrUpdateWizklubTicket from "../academic/examinations/wizklubTickets";
import WizklubCallBacks from "../academic/examinations/wizklubCallBacks";
import AddOrUpdateWizklubCallBackTicket from "../academic/examinations/wizklubCallBackTickets/addorUpdateWizklubCallBackTicket";
import SummerCampBranchesManager from "../academic/examinations/summerCampBranchesManager";
import WizklubBranchesManager from "../academic/examinations/wizklubBranchesManager";
import WizklubBranchesTeamLead from "../academic/examinations/wizklubBrnchesTeamLead";
import NonChaitanyaSummerCampStudents from "../academic/examinations/nonChaitanyaSummerCampStudents";
import NonChaitanyaAgentTargets from "../academic/examinations/nonChaitanyaSummerCampTargets";
import NonChaitanyaSummerCampCallBacks from "../academic/examinations/nonChaitanyaSummerCampCallBacks";
import NonChaitanyaSummerCampCompletedTargets from "../academic/examinations/nonChaitanyaSummerCampCompletedTargets";
import NonChaitanyaSummerCampTicket from "../academic/examinations/nonChaitanyaSummerCampTicket";
import NonChaitanyaSummerCampTargetTicket from "../academic/examinations/nonChaitanyaSummerCampTargetTicket";
import NonChaitanyaSummerCampCallBackTicket from "../academic/examinations/nonChaitanyaSummerCampCallBackTicket";
import WizklubPreviousYearStudents from "../academic/examinations/wizklubPreviousYearPaidStudents";
import WizklubCompletedStudents from "../academic/examinations/wizklubCompletedStudents";
import WizklubAgentCallSummary from "../academic/examinations/wizklubAgentsCallSummary";
import WizklubAgentWiseCallLogs from "../academic/examinations/wizklubAgentWiseCallLogs";
import WizklubSales from "../academic/examinations/wizkliubSales";
import { LeaderBoard } from "../academic/examinations/LeaderBoard";
import WizklubDashboard from "../academic/examinations/wizklubDashboard";
import WizklubHourlyReport from "../academic/examinations/wizklubHourlyReport";
import PhoneNumberToStudent from "../academic/examinations/phoneNumberToStudentSearch";
import SummerCampBranchesTeamLead from "../academic/examinations/summerCampTeamLeadBranches";
import WizklubSalesDisplay from "../academic/examinations/wizklubSalesDisplay";
import SummerCampHourlyReport from "../academic/examinations/summerCampHourlyReport";
import NonChaitanyaSummerCampCategories from "../academic/examinations/nonChaitanyaSummerCampCategories";
import NonChaitanyaSummerCampAddCategory from "../academic/examinations/nonChaitanyaSummerCampCategories/addNonChaitanyaSummerCampCategory";
import NonChaitanyaSummerCampEditCategory from "../academic/examinations/nonChaitanyaSummerCampCategories/editNonChaitanyaSummerCampCategory";
import NonChaitanyaSummerCampSubCategories from "../academic/examinations/nonChaitanyaSummerCampSubCategory";
import NonChaitanyaSummerCampAddSubCategory from "../academic/examinations/nonChaitanyaSummerCampSubCategory/addNonChaitanyaSummerCampSubCategory";
import NonChaitanyaSummerCampEditSubCatgegory from "../academic/examinations/nonChaitanyaSummerCampSubCategory/editNonChaitanyaSummerCampSubCategory";
import SummerCampPendingEnrollmentsStudents from "../academic/examinations/summerCampPendingEnrollments";
import NonChaitanyaAgentCallSummary from "../academic/examinations/nonChaitanyaAgentCallSummary";
import NonChaitanyaAgentWiseCallLogs from "../academic/examinations/nonChaitanyaAgentWiseCallLogs";
import NonChaitanyaSummerCampHourlyReport from "../academic/examinations/nonChaitanyaHourlyReport";
import NonChaitanyaAgentWiseStudentSales from "../academic/examinations/nonChaitanyaSummerCampSales";
import SummerCampTelanganaStudents from "../academic/examinations/summerCampTelanganaStudents";
import WizklubAgentCallReports from "../academic/examinations/wizklubAgentsReports";
import WizklubAgentWiseBranchReports from "../academic/examinations/wizklubAgentWiseBranchReports";
import SummerCampAgentCallReports from "../academic/examinations/summerCampAgentReports";
import SummerCampAgentWiseBranchReports from "../academic/examinations/summercampAgentWiseBranchReports";
import SummerCampCallLogs from "../academic/examinations/summerCampCallLogs";
import WizklubCallLogs from "../academic/examinations/wizklubCallLogs";
import NonChaitanyaCallLogs from "../academic/examinations/nonChaitanyaCallLogs";
import CallParticipantCategories from "../academic/examinations/callParticipantCategories";
import CallParticipantAddCategory from "../academic/examinations/callParticipantCategories/add";
import CallParticipantEditCategory from "../academic/examinations/callParticipantCategories/edit";
import CallParticipantSubCategories from "../academic/examinations/callParticipantSubCategories";
import AddCallParticipantSubCategories from "../academic/examinations/callParticipantSubCategories/add";
import EditCallParticipantSubCategories from "../academic/examinations/callParticipantSubCategories/edit";
import CallParticipantList from "../academic/examinations/callParticipantList";
import AddCallParticipant from "../academic/examinations/callParticipantList/add";
import EditCallParticipant from "../academic/examinations/callParticipantList/edit";
import AddOrUpdateCallParticipant from "../academic/examinations/callParticipantTicket/addOrUpdateCallParticipant";
import SummerCampScAndNonScAgentCallSummary from "../academic/examinations/summerCampScAndNonScAgentCallSummary";
import SummerCampScAndNonScAgentWiseCallLogs from "../academic/examinations/summerCampScAndNonScAgentWiseCallLogs";
import EmployeeBranches from "../academic/examinations/employeeBranches";
import CallParticipantAgentCallSummary from "../academic/examinations/callParticipantsAgentCallSummary";
import CallParticipantAgentWiseCallLogs from "../academic/examinations/callParticipantAgentWiseCallLogs";
import CallParticipantHourlyReport from "../academic/examinations/callParticipantHourlyReport";
import CallParticipantCallLogs from "../academic/examinations/callParticipantsCallLogs";
import EmployeeDetails from "../academic/examinations/employeeDetails";
import EmployeeCategories from "../academic/examinations/employeeCategory";
import EmployeeAddCategory from "../academic/examinations/employeeCategory/add";
import EmployeeEditCategory from "../academic/examinations/employeeCategory/edit";
import EmployeeSubCategories from "../academic/examinations/employeeSubCategory";
import AddEmployeeSubCategories from "../academic/examinations/employeeSubCategory/add";
import EditEmployeeSubCategories from "../academic/examinations/employeeSubCategory/edit";
import AddOrUpdateEmployeeTicket from "../academic/examinations/employeeTicket";
import EmployeeCallSummary from "../academic/examinations/employeeCallSummary";
import EmployeeAgentWiseCallLogs from "../academic/examinations/employeeWiseCallLog";
import EmployeebHourlyReport from "../academic/examinations/employeeHourlyReport";
import EmployeeCallLogs from "../academic/examinations/employeeCallLog";
import EmployeeServiceDivision from "../academic/examinations/employeeServiceDivision";
import EmployeeAddServiceDivision from "../academic/examinations/employeeServiceDivision/add";
import EmployeeEditServiceDivision from "../academic/examinations/employeeServiceDivision/edit";
import WizklubTrainerBranches from "../academic/examinations/wizklubTrainerBranches";
import WizklubTrainerStudents from "../academic/examinations/wizklubTrainerStudents";
import EmployeeUserProfile from "../academic/examinations/employeeUserManagement";
import EmployeeUsers from "../academic/examinations/employeeUsers";
import EmployeeTeamManagmentList from "../academic/examinations/employeeTeamManagment/employeeTeamManagment";
import AddEmployeeTeamManagement from "../academic/examinations/employeeTeamManagment/addEmployeeTeamManagment";
import EditEmployeeTeamManagementList from "../academic/examinations/employeeTeamManagment/editEmployeeTeamManagmentList";
import WizklubAgentWiseInputs from "../academic/examinations/wizklubAgentWiseInputs";
import WizklubAgentWiseBranchInputs from "../academic/examinations/wizklubAgentWiseInputs/wizklubAgentWiseBranchInputs";
import WizklubCallsConnected from "../academic/examinations/wizklubAgentWiseInputs/wizklubCallsConnected";
import WizklubCallsGreaterThan1Minute30Seconds from "../academic/examinations/wizklubAgentWiseInputs/WizklubCallsGreaterThan1Minute30Seconds";
import WizklubCallLessThan1Minute from "../academic/examinations/wizklubAgentWiseInputs/wizklubCallsLEssThan1Minute";
import WizklubCallLessThan1Minute30Seconds from "../academic/examinations/wizklubAgentWiseInputs/wizklubCallsLEssThan1Minute30Seconds";
import WizklubCallLessThan30Seconds from "../academic/examinations/wizklubAgentWiseInputs/wizklubCallsLEssThan30Seconds";
import WizklubNoOfCallsInputs from "../academic/examinations/wizklubAgentWiseInputs/wizklubNoOfCalls";
import WizklubUniqueLeadTouchInputs from "../academic/examinations/wizklubAgentWiseInputs/wizklubUniqueLeadTouch";
import WizklubUniqueLeadTouchConnectedInputs from "../academic/examinations/wizklubAgentWiseInputs/wizklubUniqueLeadTouchConnnected";
import CrmLandingPage from "../academic/examinations/crmLandingPage";
import EmployeeDailed from "../academic/examinations/employeeDailed";
import WizklubTrainerFollowUpBranches from "../academic/examinations/wizklubTrainerFollowUpBranches";
import WizklubTrainerFollowUpStudents from "../academic/examinations/wizklubTrainerFollowUpStudents";
import WizklubTrainerDailedBranches from "../academic/examinations/wizklubTrainerDailedBranches";
import WizklubTrainerDailedStudents from "../academic/examinations/wizklubTrainerDailedStudents";
import WizklubBranchUniqueLeadTouch from "../academic/examinations/wizklubBranchUniqueLeads";
import Seminors from "../academic/examinations/seminors";
import AddSeminors from "../academic/examinations/seminors/add";
import EditSeminors from "../academic/examinations/seminors/edit";
import WizklubBranchCVR from "../academic/examinations/wizklubBranchCvr";
import WizklubAssignBranchTarget from "../academic/examinations/wizklubAssignBranchTarget";
import WizklubAssignBranchCategory from "../academic/examinations/wizklubAssignBranchCategory";
import WizklubWeeklySales from "../academic/examinations/wizklubWeeklySales";
import AddTargetForWizklubWeeklySales from "../academic/examinations/wizklubWeeklySales/add";
import EditTargetForWizklubWeeklySales from "../academic/examinations/wizklubWeeklySales/edit";
import WizklubTrainerSales from "../academic/examinations/wizklubTrainerSales";
import WizklubDailyTarget from "../academic/examinations/wizklubDailyTargets";
import AddTargetForWizklubDailySales from "../academic/examinations/wizklubDailyTargets/add";
import EditTargetForWizklubDailySales from "../academic/examinations/wizklubDailyTargets/edit";
import WizklubTrainerCallLogs from "../academic/examinations/wizklubTrainerCallLogs";
import WizklubTrainerDashboard from "../academic/examinations/wizklubTrainerDashboard";
import WizklubTrainerAssignmentToManager from "../academic/examinations/wizklubTrainerAssignmentToManagers";
import AddWizklubTrainerAssignmentToManager from "../academic/examinations/wizklubTrainerAssignmentToManagers/add";
import EditWizklubTrainerAssignmentToManager from "../academic/examinations/wizklubTrainerAssignmentToManagers/edit";
import EmployeeDashboard from "../academic/examinations/employeeDashboard";
import WizklubAgentsAttendance from "../academic/examinations/wizklubUserAttendance";
import WizklubBranchWiseSaleData from "../academic/examinations/wizklubBranchData/saleData";
import WizklubBranchWiseNotIntrestedData from "../academic/examinations/wizklubBranchData/notIntrested";
import WizklubBranchWiseIntrestedData from "../academic/examinations/wizklubBranchData/intrested";
import WizklubBranchWiseConnectedData from "../academic/examinations/wizklubBranchData/connected";
import WizklubBranchWiseCallBackData from "../academic/examinations/wizklubBranchData/callBackData";
import ScoreEmployeeDetails from "../academic/examinations/score/scoreEmployees";
import ScoreEmployeeBranches from "../academic/examinations/score/scoreBranchesForEmployees";
import ScoreDailedEmployeeBranches from "../academic/examinations/score/scoreBranchesForDailedEmployees";
import ScoreEmployeeDailed from "../academic/examinations/score/scoreDailedEmployees";
import EmployeeBranchAssignment from "../academic/examinations/score/employeeBranchAssignment";
import EditBranchAssignment from "../academic/examinations/score/employeeBranchAssignment/editBranchAssignment";
import TeacherRoles from "../academic/examinations/score/TeacherRole";
import AddTeacherRole from "../academic/examinations/score/TeacherRole/add";
import EditTeacherRole from "../academic/examinations/score/TeacherRole/edit";
import AddBranchAssignment from "../academic/examinations/score/employeeBranchAssignment/add";
import ScoreReports from "../academic/examinations/score/reports";
import MetaEmployeeLoginDetailsUpload from "../academic/examinations/metaEmployeeLoginDetailsUpload";
import EmployeeWorkAssignmnet from "../employeeWorkAssignmnet";
import AddEmployeeWorkAssignment from "../employeeWorkAssignmnet/add";
import EditEmployeeWorkAssignment from "../employeeWorkAssignmnet/edit";
import PendingEmployeeDetails from "../employeeWorkAssignmnet/pendingWork";
import CompletedEmployeeDetails from "../employeeWorkAssignmnet/completedWork";
import SmsToStudent from "../academic/examinations/phoneNumberToStudentSearch/coustumnumberToSearch";
import CompletedCallParticipantList from "../academic/examinations/callParticipantList/completed";
import AdminDashboard1 from "../mainMenu/adminDashboard/adminDashboard1";
import WizklubOneYearPreviousYearStudents from "../academic/examinations/wizklubPreviousYearPaidStudents/previous";
import WizklubDailyConversationTarget from "../academic/examinations/wizklubDailyTargets";
import WizklubDailySalesTarget from "../academic/examinations/wizklubDailyTargets/salesTarget";
import AddTargetForWizklubDailySalesTarget from "../academic/examinations/wizklubDailyTargets/saleTargetAdd";
import EditTargetForWizklubDailySalesTarget from "../academic/examinations/wizklubDailyTargets/salesTargetEdit";
import PrisamCategories from "../academic/examinations/prisam/masters/categories";
import PrisamAddCategory from "../academic/examinations/prisam/masters/categories/add";
import PrisamEditCategory from "../academic/examinations/prisam/masters/categories/edit";
import PrisamSubCategories from "../academic/examinations/prisam/masters/SubCategories";
import AddPrisamSubCategories from "../academic/examinations/prisam/masters/SubCategories/add";
import EditPrisamSubCategories from "../academic/examinations/prisam/masters/SubCategories/edit";
import PrismTeamManagmentList from "../academic/examinations/prisam/masters/teamManagement";
import AddPrismTeamManagement from "../academic/examinations/prisam/masters/teamManagement/add";
import EditPrismTeamManagementList from "../academic/examinations/prisam/masters/teamManagement/edit";
import PrismPendingEmployeeDetails from "../academic/examinations/prisam/leads/pending";
import PrismCompletedEmployeeDetails from "../academic/examinations/prisam/leads/completed";
import AddPrismLead from "../academic/examinations/prisam/leads/add";
import EditPrismLead from "../academic/examinations/prisam/leads/edit";
import PrismLeadTicket from "../academic/examinations/prisam/leads/ticket";
import PrismImportData from "../academic/examinations/prisam/leads/import";
import PrismOverallCallLogs from "../academic/examinations/prisam/reports/overallCallLogs";
import PrismAgentCallSummary from "../academic/examinations/prisam/reports/agentCallSummary";
import PrismAgentWiseCallLogs from "../academic/examinations/prisam/reports/agentCallSummaryOffParticularAgent";
import CallParticipantImportData from "../academic/examinations/callParticipantList/import";

const routes = all_routes;

export const publicRoutes = [
   {
    path: routes.callParticipantImport,
    element: <CallParticipantImportData />
  },
  {
    path: routes.prismOverAllCallLogs,
    element: <PrismOverallCallLogs />
  },
  {
    path: routes.prismAgentCallSummary,
    element: <PrismAgentCallSummary />
  },
  {
    path: routes.prismAgentWiseCallLog,
    element: <PrismAgentWiseCallLogs />
  },
  {
    path: routes.prismLeadsUpload,
    element: <PrismImportData />
  },
  {
    path: routes.prismAddOrUpdateTicket,
    element: <PrismLeadTicket />
  },
  {
    path: routes.addPrismLead,
    element: <AddPrismLead />
  },
  {
    path: routes.editPrismLead,
    element: <EditPrismLead />
  },
  {
    path: routes.prismPendingLeads,
    element: <PrismPendingEmployeeDetails />
  },
  {
    path: routes.prismCompletedLeads,
    element: <PrismCompletedEmployeeDetails />
  },
  {
    path: routes.prismTeamManagement,
    element: <PrismTeamManagmentList />
  },
  {
    path: routes.prismTeamManagement,
    element: <PrismTeamManagmentList />
  },
  {
    path: routes.prismAddTeamManagement,
    element: <AddPrismTeamManagement />
  },
  {
    path: routes.prismEditTeamManagement,
    element: <EditPrismTeamManagementList />
  },

  {
    path: routes.prisamCategories,
    element: <PrisamCategories />
  },
  {
    path: routes.prisamAddCategories,
    element: <PrisamAddCategory />
  },
  {
    path: routes.prisamEditCategories,
    element: <PrisamEditCategory />
  },

  {
    path: routes.prisamSubCategories,
    element: <PrisamSubCategories />
  },
  {
    path: routes.prisamAddSubCategories,
    element: <AddPrisamSubCategories />
  },
  {
    path: routes.prisamEditSubCategories,
    element: <EditPrisamSubCategories />
  },

  {
    path: routes.wizklubDailySalesTaarget,
    element: <WizklubDailySalesTarget />
  },
  {
    path: routes.AddWizklubDailySalesTaarget,
    element: <AddTargetForWizklubDailySalesTarget />
  },
  {
    path: routes.EditWizklubDailySalesTaarget,
    element: <EditTargetForWizklubDailySalesTarget />
  },
  {
    path: routes.wizklubOneYearPreviousYearStudents,
    element: <WizklubOneYearPreviousYearStudents />,
  },
  {
    path: routes.adminDashboard1,
    element: <AdminDashboard1 />
  },
  {
    path: routes.CompletedCallParticipantList,
    element: <CompletedCallParticipantList />,
  },
  {
    path: routes.smstoStudent,
    element: <SmsToStudent />,
  },
  {
    path: routes.pendingEmployeeDetails,
    element: <PendingEmployeeDetails />,
  },
  {
    path: routes.completedEmployeeDetails,
    element: <CompletedEmployeeDetails />,
  },
  {
    path: routes.employeeWorkAssignment,
    element: <EmployeeWorkAssignmnet />,
  },
  {
    path: routes.addEmployeeWorkAssignment,
    element: <AddEmployeeWorkAssignment />,
  },
  {
    path: routes.editEmployeeWorkAssignment,
    element: <EditEmployeeWorkAssignment />,
  },

  {
    path: routes.metaEmployeeLoginDetailsUpload,
    element: <MetaEmployeeLoginDetailsUpload />,
  },
  {
    path: routes.scoreEmployeeBranches,
    element: <ScoreEmployeeBranches />,
  },
  {
    path: routes.scoreDailedEmployeeBranches,
    element: <ScoreDailedEmployeeBranches />,
  },
  {
    path: routes.scoreEmployeeDetails,
    element: <ScoreEmployeeDetails />,
  },
  {
    path: routes.scoreDailedEmployeeDetails,
    element: <ScoreEmployeeDailed />,
  },
  {
    path: routes.employeeBranchAssignment,
    element: <EmployeeBranchAssignment />,
  },
  {
    path: routes.editBranchAssignment,
    element: <EditBranchAssignment />,
  },
  {
    path: routes.addBranchAssignment,
    element: <AddBranchAssignment />,
  },
  {
    path: routes.teacherRole,
    element: <TeacherRoles />,
  },
  {
    path: routes.addTeacherRole,
    element: <AddTeacherRole />,
  },
  {
    path: routes.editTeacherRole,
    element: <EditTeacherRole />,
  },

  {
    path: routes.scoreReports,
    element: <ScoreReports />,
  },


  {
    path: routes.wizklubBranchWiseNotIntrestedData,
    element: <WizklubBranchWiseNotIntrestedData />,
  },
  {
    path: routes.wizklubBranchWiseIntrestedata,
    element: <WizklubBranchWiseIntrestedData />,
  },
  {
    path: routes.wizklubBranchWiseConnectedData,
    element: <WizklubBranchWiseConnectedData />,
  }, {
    path: routes.wizklubBranchWiseCallBackData,
    element: <WizklubBranchWiseCallBackData />,
  },

  {
    path: routes.wizklubBranchWiseSaleData,
    element: <WizklubBranchWiseSaleData />,
  },
  {
    path: routes.wizklubAgentsAttendance,
    element: <WizklubAgentsAttendance />
  },
  {
    path: routes.employeeDashboard,
    element: <EmployeeDashboard />
  },
  {
    path: routes.wizklubTrainerAssignmentToManager,
    element: <WizklubTrainerAssignmentToManager />
  },
  {
    path: routes.addWizklubTrainerAssignmentToManager,
    element: <AddWizklubTrainerAssignmentToManager />
  },
  {
    path: routes.EditWizklubTrainerAssignmentToManager,
    element: <EditWizklubTrainerAssignmentToManager />
  },
  {
    path: routes.wizklubTrainerDashboard,
    element: <WizklubTrainerDashboard />
  },
  {
    path: routes.wizklubTrainerCallLogs,
    element: <WizklubTrainerCallLogs />
  },
  {
    path: routes.wizklubDailyTargets,
    element: <WizklubDailyConversationTarget />
  },
  {
    path: routes.addWizklubDailyTarget,
    element: <AddTargetForWizklubDailySales />
  },
  {
    path: routes.editWizklubDailyTarget,
    element: <EditTargetForWizklubDailySales />
  },
  {
    path: routes.wizklubTrainerSales,
    element: <WizklubTrainerSales />
  },
  {
    path: routes.wizklubWeeklySales,
    element: <WizklubWeeklySales />
  },
  {
    path: routes.addTargetForWizklubWeeklySales,
    element: <AddTargetForWizklubWeeklySales />
  },
  {
    path: routes.editTargetForWeeklySales,
    element: <EditTargetForWizklubWeeklySales />
  },
  {
    path: routes.wizklubAssignBranchCategory,
    element: <WizklubAssignBranchCategory />
  },
  {
    path: routes.wizklubAssignBranchTarget,
    element: <WizklubAssignBranchTarget />
  },
  {
    path: routes.wizklubBranchCvr,
    element: <WizklubBranchCVR />
  },
  {
    path: routes.seminors,
    element: <Seminors />
  },
  {
    path: routes.addSeminor,
    element: <AddSeminors />
  },
  {
    path: routes.editSeminor,
    element: <EditSeminors />
  },
  {
    path: routes.wizklubBranchUniqueLeadTouch,
    element: <WizklubBranchUniqueLeadTouch />
  },
  {
    path: routes.employeeDailed,
    element: <EmployeeDailed />
  },
  {
    path: routes.wizklubTrainerFollowUpBranches,
    element: <WizklubTrainerFollowUpBranches />
  },
  {
    path: routes.wizklubTrainerFollowUpStudents,
    element: <WizklubTrainerFollowUpStudents />
  },
  {
    path: routes.wizklubTrainerDailedBranches,
    element: <WizklubTrainerDailedBranches />
  },
  {
    path: routes.wizklubTrainerDailedStudents,
    element: <WizklubTrainerDailedStudents />
  },


  {
    path: routes.crmLandingPage,
    element: <CrmLandingPage />
  },
  {
    path: routes.wizklubInputs,
    element: <WizklubAgentWiseInputs />
  },
  { path: routes.WizklubAgentWiseBranchInputs, element: <WizklubAgentWiseBranchInputs /> },
  { path: routes.WizklubCallsConnected, element: <WizklubCallsConnected /> },
  { path: routes.WizklubCallsGreaterThan1Minute30Seconds, element: <WizklubCallsGreaterThan1Minute30Seconds /> },
  { path: routes.WizklubCallLessThan1Minute, element: <WizklubCallLessThan1Minute /> },
  { path: routes.WizklubCallLessThan1Minute30Seconds, element: <WizklubCallLessThan1Minute30Seconds /> },
  { path: routes.WizklubCallLessThan30Seconds, element: <WizklubCallLessThan30Seconds /> },
  { path: routes.WizklubNoOfCallsInputs, element: <WizklubNoOfCallsInputs /> },
  { path: routes.WizklubUniqueLeadTouchInputs, element: <WizklubUniqueLeadTouchInputs /> },
  { path: routes.WizklubUniqueLeadTouchConnectedInputs, element: <WizklubUniqueLeadTouchConnectedInputs /> },
  {
    path: routes.employeeTeamManagment,
    element: <EmployeeTeamManagmentList />
  },

  {
    path: routes.addEmployeeTeamManagment,
    element: <AddEmployeeTeamManagement />
  },
  {
    path: routes.editEmployeeTeamManagment,
    element: <EditEmployeeTeamManagementList />
  },

  {
    path: routes.employeeUsers,
    element: <EmployeeUsers />
  },
  {
    path: routes.employeeUserProfile,
    element: <EmployeeUserProfile />
  },
  {
    path: routes.wizklubTrainerStudents,
    element: <WizklubTrainerStudents />
  },
  {
    path: routes.wizklubTrainerBranches,
    element: <WizklubTrainerBranches />
  },
  {
    path: routes.employeeServiceDivision,
    element: <EmployeeServiceDivision />
  },
  {
    path: routes.employeeAddServiceDivision,
    element: <EmployeeAddServiceDivision />
  },
  {
    path: routes.employeeEditServiceDivision,
    element: <EmployeeEditServiceDivision />
  },
  {
    path: routes.employeeAgentCallSummary,
    element: <EmployeeCallSummary />
  },
  {
    path: routes.employeeAgentWiseCallLog,
    element: <EmployeeAgentWiseCallLogs />
  },
  {
    path: routes.employeeHourlyReport,
    element: <EmployeebHourlyReport />
  },
  {
    path: routes.employeecallLogs,
    element: <EmployeeCallLogs />
  },


  {
    path: routes.addOrUpdateEmployeeTicket,
    element: <AddOrUpdateEmployeeTicket />
  },
  {
    path: routes.employeeCategories,
    element: <EmployeeCategories />
  },
  {
    path: routes.employeeAddCategories,
    element: <EmployeeAddCategory />
  },
  {
    path: routes.employeeEditCategories,
    element: <EmployeeEditCategory />
  },
  {
    path: routes.employeeSubCategories,
    element: <EmployeeSubCategories />
  },
  {
    path: routes.employeeAddSubCategories,
    element: <AddEmployeeSubCategories />
  },
  {
    path: routes.employeeEditSubCategories,
    element: <EditEmployeeSubCategories />
  },

  {
    path: routes.employeeDetails,
    element: <EmployeeDetails />
  },
  {
    path: routes.callParticipantAgentCallSummary,
    element: <CallParticipantAgentCallSummary />
  },
  {
    path: routes.callParticipantAgentWiseCallLog,
    element: <CallParticipantAgentWiseCallLogs />
  },
  {
    path: routes.callParticipantHourlyReport,
    element: <CallParticipantHourlyReport />
  },
  {
    path: routes.callParticipantcallLogs,
    element: <CallParticipantCallLogs />
  },

  {
    path: routes.employeeBranches,
    element: <EmployeeBranches />
  },
  {
    path: routes.summercampScAndNonScAgentCallSummary,
    element: <SummerCampScAndNonScAgentCallSummary />
  },
  {
    path: routes.summercampScAndNonScAgentWiseCallLogs,
    element: <SummerCampScAndNonScAgentWiseCallLogs />
  },
  {
    path: routes.addOrUpdateCallParticipantTicket,
    element: <AddOrUpdateCallParticipant />
  },
  {
    path: routes.callParticipantList,
    element: <CallParticipantList />
  },
  {
    path: routes.addCallParticipant,
    element: <AddCallParticipant />
  },
  {
    path: routes.editCallParticipant,
    element: <EditCallParticipant />
  },
  {
    path: routes.callParticipantCategories,
    element: <CallParticipantCategories />
  },
  {
    path: routes.callParticipantAddCategory,
    element: <CallParticipantAddCategory />
  },
  {
    path: routes.callParticipantEditCategory,
    element: <CallParticipantEditCategory />
  },
  {
    path: routes.callParticipantSubCategories,
    element: <CallParticipantSubCategories />
  },
  {
    path: routes.addCallParticipantSubCategories,
    element: <AddCallParticipantSubCategories />
  },
  {
    path: routes.editCallParticipantSubCategories,
    element: <EditCallParticipantSubCategories />
  },


  {
    path: routes.summercampCallLogs,
    element: <SummerCampCallLogs />
  },
  {
    path: routes.wizklubCallLogs,
    element: <WizklubCallLogs />
  },
  {
    path: routes.nonChaitanyaCallLogs,
    element: <NonChaitanyaCallLogs />
  },

  {
    path: routes.SummerCampAgentReports,
    element: <SummerCampAgentCallReports />
  },
  {
    path: routes.SummerCampAgentBranchReports,
    element: <SummerCampAgentWiseBranchReports />
  },
  {
    path: routes.wizklubAgentReports,
    element: <WizklubAgentCallReports />
  },
  {
    path: routes.wizklubAgentBranchReports,
    element: <WizklubAgentWiseBranchReports />
  },
  {
    path: routes.SummerCampTelanganaStudents,
    element: <SummerCampTelanganaStudents />
  },
  {
    path: routes.NonChaitanyaSales,
    element: <NonChaitanyaAgentWiseStudentSales />
  },
  {
    path: routes.NonChaitanyaHourlyReport,
    element: <NonChaitanyaSummerCampHourlyReport />
  },
  {
    path: routes.NonChaitanyaAgentWiseCallLogs,
    element: <NonChaitanyaAgentWiseCallLogs />
  },
  {
    path: routes.NonChaitanyaAgentCallSummary,
    element: <NonChaitanyaAgentCallSummary />
  },
  {
    path: routes.SummerCampPendingEnrollments,
    element: <SummerCampPendingEnrollmentsStudents />
  },

  {
    path: routes.NonChaitanyaCategories,
    element: <NonChaitanyaSummerCampCategories />
  }, {
    path: routes.NonChaitanyaAddCategories,
    element: <NonChaitanyaSummerCampAddCategory />
  }, {
    path: routes.NonChaitanyaEditCategories,
    element: <NonChaitanyaSummerCampEditCategory />
  }, {
    path: routes.NonChaitanyaSubCategories,
    element: <NonChaitanyaSummerCampSubCategories />
  }, {
    path: routes.NonChaitanyaAddSubCategories,
    element: <NonChaitanyaSummerCampAddSubCategory />
  }, {
    path: routes.NonChaitanyaEditSubCategories,
    element: <NonChaitanyaSummerCampEditSubCatgegory />
  },

  {
    path: routes.summmerCampHourlyReport,
    element: <SummerCampHourlyReport />
  },
  {
    path: routes.summerCampTeamLeadBranches,
    element: <SummerCampBranchesTeamLead />
  },
  {
    path: routes.phoneNumberToStudent,
    element: <PhoneNumberToStudent />
  },
  {
    path: routes.wizklubHourlyReport,
    element: <WizklubHourlyReport />
  },
  {
    path: routes.wizklubDashboard,
    element: <WizklubDashboard />
  },
  {
    path: routes.wizklubSales,
    element: <WizklubSales />
  },
  {
    path: routes.wizklubAgentCallSummary,
    element: <WizklubAgentCallSummary />
  },
  {
    path: routes.wizklubAgentWiseCallLogs,
    element: <WizklubAgentWiseCallLogs />
  },
  {
    path: routes.wizklubPreviousYearPaidStudents,
    element: <WizklubPreviousYearStudents />
  },
  {
    path: routes.wizklubCompletedStudents,
    element: <WizklubCompletedStudents />
  },
  {
    path: routes.NonChaitanyaSummerCampCallBackTicket,
    element: <NonChaitanyaSummerCampCallBackTicket />
  },
  {
    path: routes.NonChaitanyaSummerCampTargetTicket,
    element: <NonChaitanyaSummerCampTargetTicket />
  },
  {
    path: routes.NonChaitanyaSummerCampTicket,
    element: <NonChaitanyaSummerCampTicket />
  },
  {
    path: routes.NonChaitanyaSummerCampCompletedTargets,
    element: <NonChaitanyaSummerCampCompletedTargets />
  },
  {
    path: routes.NonChaitanyaSummerCampCallBacks,
    element: <NonChaitanyaSummerCampCallBacks />
  },
  {
    path: routes.NonChaitanyaAgentTargets,
    element: <NonChaitanyaAgentTargets />
  },
  {
    path: routes.NonChaiatnyaSummerCampStudents,
    element: <NonChaitanyaSummerCampStudents />
  },
  {
    path: routes.wizklubBranchesManager,
    element: <WizklubBranchesManager />
  },
  {
    path: routes.wizklubBranchesTeamLead,
    element: <WizklubBranchesTeamLead />
  },
  {
    path: routes.summercampBranchesManager,
    element: <SummerCampBranchesManager />
  },
  {
    path: routes.addOrUpdateWizklubCallBackTicket,
    element: <AddOrUpdateWizklubCallBackTicket />
  },
  {
    path: routes.wizklubCallBacks,
    element: <WizklubCallBacks />
  },
  {
    path: routes.addOrUpdateWizklubTicket,
    element: <AddOrUpdateWizklubTicket />
  },
  {
    path: routes.wizklubStudents,
    element: <WizklubStudents />
  },
  {
    path: routes.wizklubEditSubCategories,
    element: <EditWizklubSubCategories />
  },
  {
    path: routes.wizklubAddSubCategories,
    element: <AddWizklubSubCategories />
  },
  {
    path: routes.wizklubSubCategories,
    element: <WizklubSubCategories />
  },
  {
    path: routes.wizklubEditCategories,
    element: <WizClubEditCategory />
  },
  {
    path: routes.wizklubAddCategories,
    element: <WizClubAddCategory />
  },
  {
    path: routes.wizklubCategories,
    element: <WizClubCategories />
  },
  {
    path: routes.summerCampCompletedTargets,
    element: <SummerCampCompletedTargets />
  },
  {
    path: routes.editAgentGroups,
    element: <EditAgentGroup />
  },
  {
    path: routes.addAgentGroups,
    element: <AddAgentGroup />
  },
  {
    path: routes.agentGroupsList,
    element: <AgentGroups />
  },
  {
    path: routes.addAgentGroupTypes,
    element: <AddAgentGroupType />
  },
  {
    path: routes.editAgentGroupTypes,
    element: <EditAgentGroupType />
  },
  {
    path: routes.agentGroupTypesList,
    element: <AgentGroupTypes />
  },
  {
    path: routes.editTeamManagement,
    element: <EditTeamManagementList />
  },
  {
    path: routes.addTeamManagement,
    element: <AddTeamManagement />
  },
  {
    path: routes.teamManagementList,
    element: <TeamManagmentList />
  },
  {
    path: routes.agentWiseStudentSales,
    element: <AgentWiseStudentSales />
  },
  {
    path: routes.leaderboard,
    element: <LeaderBoard />
  },
  {
    path: routes.BranchesWizclubOrnot,
    element: <BranchWizclubOrOffline />
  },
  {
    path: routes.summerCampEditCallBackTicket,
    element: <UpdateSummerCampCallBackTicket />
  },
  {
    path: routes.summerCampAddCallBackTicket,
    element: <AddSummerCampCallBackTicket />
  },
  {
    path: routes.summerCampEditTargetTicket,
    element: <UpdateSummerCampTargetTicket />
  },
  {
    path: routes.summeerCampAddTargetTicket,
    element: <AddSummerCampTargetTicket />
  },
  {
    path: routes.SummerCampCallBacks,
    element: <SummerCampCallBacks />
  },
  {
    path: routes.agentTargets,
    element: <AgentTargets />
  },
  {
    path: routes.activity,
    element: <NotificationActivities />
  },
  {
    path: routes.agentWiseStudentStatus,
    element: <AgentWiseStudentStatus />
  },
  {
    path: routes.agentWiseTargetStatus,
    element: <AgentWiseTargetStatus />
  },
  {
    path: routes.agentWiseCallLogs,
    element: <AgentWiseCallLogs />
  },
  {
    path: routes.agentCallSummary,
    element: <AgentCallSummary />
  },
  {
    path: routes.profile,
    element: <Profile />
  },
  {
    path: routes.SummerCampStudents,
    element: <SummerCampStudents />
  },
  {
    path: routes.SummerCampAddTicket,
    element: <AddSummerCampTicket />
  },
  {
    path: routes.SummerCampUpdateTicket,
    element: <UpdateSummerCampTicket />
  },
  {
    path: routes.SummerCampDisposition,
    element: <SummerCampDisposition />
  }, {
    path: routes.SummerCampAddDisposition,
    element: <SummerCampAddDisposition />
  }, {
    path: routes.SummerCampEditDisposition,
    element: <SummerCampEditDisposition />
  }, {
    path: routes.SummerCampCategories,
    element: <SummerCampCategories />
  }, {
    path: routes.SummerCampAddCategories,
    element: <SummerCampAddCategory />
  }, {
    path: routes.SummerCampEditCategories,
    element: <SummerCampEditCategory />
  }, {
    path: routes.SummerCampSubCategories,
    element: <SummerCampSubCategories />
  }, {
    path: routes.SummerCampAddSubCategories,
    element: <SummerCampAddSubCategory />
  }, {
    path: routes.SummerCampEditSubCategories,
    element: <SummerCampEditSubCatgegory />
  }, {
    path: routes.SummerCampPriorities,
    element: <SummerCampPriorities />
  }, {
    path: routes.SummerCampAddPriorities,
    element: <SummerCampAddPriority />
  }, {
    path: routes.SummerCampEditPriorities,
    element: <SummerCampEditPriority />
  }, {
    path: routes.SummerCampTicketStatus,
    element: <SummerCampTicketStatus />
  }, {
    path: routes.SummerCampAddTicketStatus,
    element: <SummerCampAddTicketStatus />
  }, {
    path: routes.SummerCampEditTicketStatus,
    element: <SummerCampEditTicketStatus />
  },
  {
    path: routes.wizklubView,
    element: <WizklubView />
  },
  {
    path: routes.addWizklubTicket,
    element: <AddWizklubTicket />
  },
  {
    path: routes.editWizklubTicket,
    element: <EditWizklubTicket />
  },
  {
    path: routes.addTypeOfTicket,
    element: <AddTypeOfTicket />
  }, {
    path: routes.editTypeOfTicket,
    element: <EditTypeOfTicket />
  }, {
    path: routes.TypeOfTicket,
    element: <TypeOfTicket />
  },
  {
    path: routes.addDispositions,
    element: <AddDisposition />
  }, {
    path: routes.editDispositions,
    element: <EditDisposition />
  }, {
    path: routes.addCategories,
    element: <AddCategory />
  }, {
    path: routes.editCategories,
    element: <EditCategory />
  }, {
    path: routes.addSubCategories,
    element: <AddSubCategory />
  }, {
    path: routes.addPriorities,
    element: <AddPriority />
  }, {
    path: routes.editPriorities,
    element: <EditPriority />
  }, {
    path: routes.addTicketStatus,
    element: <AddTicketStatus />
  }, {
    path: routes.editTicketStatus,
    element: <EditTicketStatus />
  }, {
    path: routes.dispositions,
    element: <Dispositions />
  },
  {
    path: routes.editSubCategories,
    element: <EditSubCatgegory />
  },
  {
    path: routes.categories,
    element: <Categories />
  },
  {
    path: routes.subCategories,
    element: <SubCategories />
  },
  {
    path: routes.priorities,
    element: <Priorities />
  },
  {
    path: routes.ticketStatus,
    element: <TicketStatus />
  },
  {
    path: routes.studentData,
    element: <StudentData />
  },
  {
    path: routes.userProfile,
    element: <UserProfile />
  },
  {
    path: routes.editUser,
    element: <EditUser />
  },
  {
    path: routes.addUser,
    element: <AddUser />
  },
  {
    path: routes.users,
    element: <Users />
  },
  {
    path: routes.groups,
    element: <Groups />
  },
  {
    path: routes.addGroup,
    element: <AddGroup />
  },
  {
    path: routes.editGroup,
    element: <EditGroup />
  },
  {
    path: routes.adminDashboard,
    element: <AdminDashboard />,
    route: Route,
  },
  {
    path: routes.teacherDashboard,
    element: <TeacherDashboard />,
    route: Route,
  },
  {
    path: routes.studentDashboard,
    element: <StudentDasboard />,
    route: Route,
  },
  {
    path: routes.parentDashboard,
    element: <ParentDashboard />,
    route: Route,
  },
  {
    path: routes.calendar,
    element: <Calendar />,
    route: Route,
  },
  {
    path: routes.dataTables,
    element: <DataTable />,
    route: Route,
  },
  {
    path: routes.tablesBasic,
    element: <BasicTable />,
    route: Route,
  },

  {
    path: routes.accordion,
    element: <Accordion />,
    route: Route,
  },
  {
    path: routes.avatar,
    element: <Avatar />,
    route: Route,
  },
  {
    path: routes.badges,
    element: <Badges />,
    route: Route,
  },
  {
    path: routes.border,
    element: <Borders />,
    route: Route,
  },
  {
    path: routes.breadcrums,
    element: <Breadcrumb />,
    route: Route,
  },
  {
    path: routes.button,
    element: <Buttons />,
    route: Route,
  },
  {
    path: routes.buttonGroup,
    element: <ButtonsGroup />,
    route: Route,
  },
  {
    path: routes.cards,
    element: <Cards />,
    route: Route,
  },
  {
    path: routes.carousel,
    element: <Carousel />,
    route: Route,
  },
  {
    path: routes.colors,
    element: <Colors />,
    route: Route,
  },
  {
    path: routes.dropdowns,
    element: <Dropdowns />,
    route: Route,
  },
  {
    path: routes.grid,
    element: <Grid />,
    route: Route,
  },
  {
    path: routes.images,
    element: <Images />,
    route: Route,
  },
  {
    path: routes.lightbox,
    element: <Lightboxes />,
    route: Route,
  },
  {
    path: routes.media,
    element: <Media />,
    route: Route,
  },
  {
    path: routes.modals,
    element: <Modals />,
    route: Route,
  },
  {
    path: routes.navTabs,
    element: <NavTabs />,
    route: Route,
  },
  {
    path: routes.offcanvas,
    element: <Offcanvas />,
    route: Route,
  },
  {
    path: routes.pagination,
    element: <Pagination />,
    route: Route,
  },
  {
    path: routes.popover,
    element: <Popovers />,
    route: Route,
  },
  {
    path: routes.rangeSlider,
    element: <RangeSlides />,
    route: Route,
  },
  {
    path: routes.progress,
    element: <Progress />,
    route: Route,
  },
  {
    path: routes.spinner,
    element: <Spinner />,
    route: Route,
  },

  {
    path: routes.typography,
    element: <Typography />,
    route: Route,
  },
  {
    path: routes.video,
    element: <Video />,
    route: Route,
  },
  {
    path: routes.toasts,
    element: <Toasts />,
    route: Route,
  },
  {
    path: routes.clipboard,
    element: <ClipBoard />,
    route: Route,
  },
  {
    path: routes.counter,
    element: <Counter />,
    route: Route,
  },
  {
    path: routes.dragandDrop,
    element: <DragAndDrop />,
    route: Route,
  },
  {
    path: routes.rating,
    element: <Rating />,
    route: Route,
  },
  {
    path: routes.stickyNotes,
    element: <Stickynote />,
    route: Route,
  },
  {
    path: routes.textEditor,
    element: <TextEditor />,
    route: Route,
  },
  {
    path: routes.timeLine,
    element: <Timeline />,
    route: Route,
  },
  {
    path: routes.scrollBar,
    element: <Scrollbar />,
    route: Route,
  },
  {
    path: routes.apexChat,
    element: <Apexchart />,
    route: Route,
  },
  {
    path: routes.featherIcons,
    element: <FeatherIcons />,
    route: Route,
  },
  {
    path: routes.falgIcons,
    element: <FeatherIcons />,
    route: Route,
  },
  {
    path: routes.fantawesome,
    element: <FontawesomeIcons />,
    route: Route,
  },
  {
    path: routes.fantawesome,
    element: <FontawesomeIcons />,
    route: Route,
  },
  {
    path: routes.materialIcon,
    element: <MaterialIcons />,
    route: Route,
  },
  {
    path: routes.pe7icon,
    element: <PE7Icons />,
    route: Route,
  },
  {
    path: routes.simpleLineIcon,
    element: <SimplelineIcons />,
    route: Route,
  },
  {
    path: routes.themifyIcon,
    element: <ThemifyIcons />,
    route: Route,
  },
  {
    path: routes.typicon,
    element: <TypiconIcons />,
    route: Route,
  },
  {
    path: routes.basicInput,
    element: <BasicInputs />,
    route: Route,
  },
  {
    path: routes.weatherIcon,
    element: <WeatherIcons />,
    route: Route,
  },
  {
    path: routes.checkboxandRadion,
    element: <CheckboxRadios />,
    route: Route,
  },
  {
    path: routes.inputGroup,
    element: <InputGroup />,
    route: Route,
  },
  {
    path: routes.gridandGutters,
    element: <GridGutters />,
    route: Route,
  },
  {
    path: routes.formSelect,
    element: <FormSelect />,
    route: Route,
  },
  {
    path: routes.formMask,
    element: <FormMask />,
    route: Route,
  },
  {
    path: routes.fileUpload,
    element: <FileUpload />,
    route: Route,
  },
  {
    path: routes.horizontalForm,
    element: <FormHorizontal />,
    route: Route,
  },
  {
    path: routes.verticalForm,
    element: <FormVertical />,
    route: Route,
  },
  {
    path: routes.floatingLable,
    element: <FloatingLabel />,
    route: Route,
  },
  {
    path: routes.formValidation,
    element: <FormValidation />,
    route: Route,
  },
  {
    path: routes.reactSelect,
    element: <FormSelect2 />,
    route: Route,
  },
  {
    path: routes.formWizard,
    element: <FormWizard />,
    route: Route,
  },
  {
    path: routes.dataTable,
    element: <DataTables />,
    route: Route,
  },
  {
    path: routes.tableBasic,
    element: <TablesBasic />,
    route: Route,
  },
  {
    path: routes.iconicIcon,
    element: <IonicIcons />,
    route: Route,
  },
  // {
  //   path: routes.chart,
  //   element: <ChartJs />,
  //   route: Route,
  // },

  {
    path: routes.placeholder,
    element: <Placeholder />,
    route: Route,
  },
  {
    path: routes.sweetalert,
    element: <Alert />,
    route: Route,
  },
  {
    path: routes.alert,
    element: <AlertUi />,
    route: Route,
  },
  {
    path: routes.tooltip,
    element: <Tooltips />,
    route: Route,
  },
  {
    path: routes.ribbon,
    element: <Ribbon />,
    route: Route,
  },

  // Peoples Module
  {
    path: routes.layoutDefault,
    element: <AdminDashboard />,
  },
  {
    path: routes.layoutMini,
    element: <AdminDashboard />,
  },
  {
    path: routes.layoutRtl,
    element: <AdminDashboard />,
  },
  {
    path: routes.layoutBox,
    element: <AdminDashboard />,
  },
  {
    path: routes.layoutDark,
    element: <AdminDashboard />,
  },
];

export const authRoutes = [
  {
    path: routes.wizklubSalesDisplay,
    element: <WizklubSalesDisplay />
  },
  {
    path: routes.login,
    element: <Login />,
    route: Route,
  },
  {
    path: routes.login2,
    element: <Login2 />,
    route: Route,
  },
  {
    path: routes.login3,
    element: <Login3 />,
    route: Route,
  },
  {
    path: routes.register,
    element: <Register />,
    route: Route,
  },
  {
    path: routes.twoStepVerification,
    element: <TwoStepVerification />,
    route: Route,
  },
  {
    path: routes.twoStepVerification2,
    element: <TwoStepVerification2 />,
    route: Route,
  },
  {
    path: routes.twoStepVerification3,
    element: <TwoStepVerification3 />,
    route: Route,
  },
  {
    path: routes.emailVerification,
    element: <EmailVerification />,
    route: Route,
  },
  {
    path: routes.emailVerification2,
    element: <EmailVerification2 />,
    route: Route,
  },
  {
    path: routes.emailVerification3,
    element: <EmailVerification3 />,
    route: Route,
  },
  {
    path: routes.register,
    element: <Register />,
    route: Route,
  },
  {
    path: routes.register2,
    element: <Register2 />,
    route: Route,
  },
  {
    path: routes.register3,
    element: <Register3 />,
    route: Route,
  },
  {
    path: routes.resetPassword,
    element: <ResetPassword />,
    route: Route,
  },
  {
    path: routes.resetPassword2,
    element: <ResetPassword2 />,
    route: Route,
  },
  {
    path: routes.resetPassword3,
    element: <ResetPassword3 />,
    route: Route,
  },
  {
    path: routes.forgotPassword,
    element: <ForgotPassword />,
    route: Route,
  },
  {
    path: routes.forgotPassword2,
    element: <ForgotPassword2 />,
    route: Route,
  },
  {
    path: routes.forgotPassword3,
    element: <ForgotPassword3 />,
    route: Route,
  },
  {
    path: routes.lockScreen,
    element: <LockScreen />,
  },
  {
    path: routes.resetPasswordSuccess,
    element: <ResetPasswordSuccess />,
  },
  {
    path: routes.resetPasswordSuccess2,
    element: <ResetPasswordSuccess2 />,
  },
  {
    path: routes.resetPasswordSuccess3,
    element: <ResetPasswordSuccess3 />,
  },
];
